import { parsePhoneNumberFromString } from 'libphonenumber-js';

export default (phoneNumber) => {
  const parsedPhoneNumber = phoneNumber && parsePhoneNumberFromString(phoneNumber);
  return parsedPhoneNumber ? parsedPhoneNumber.formatNational() : phoneNumber;
};
